/**
 * Why `NotAllowedGuard` bounced the user back to the dashboard (GOTU-8247).
 *
 * The guard used to emit a single undifferentiated `showNotAllowedPopup` flag,
 * so every `customCondition` redirect inherited the DSO office-selection copy.
 * The reason travels in the navigation state and picks the popup copy below.
 */
export type TNotAllowedReason = 'office-selection' | 'best-in-dental' | 'feature-unavailable';

export const NOT_ALLOWED_POPUP_COPY: Record<
  TNotAllowedReason,
  { title: string; description: string }
> = {
  'office-selection': {
    title: 'Select Office',
    description:
      'To ensure your action is directed to the right location, please select an office by tapping "Switch Account" on the "Dashboard" page first.',
  },
  'best-in-dental': {
    title: "Best in Dental isn't available for this office",
    description:
      'This office is not part of the Best in Dental program. If you think this is a mistake, please contact support.',
  },
  'feature-unavailable': {
    title: "This feature isn't available for this office",
    description: 'If you think this is a mistake, please contact support.',
  },
};
